import { FunctionComponent, useCallback } from 'react'
import { Grid, useTheme } from '@mui/material'
import { useWidgetContext } from '@dxp-module/common'
import { MyAccountTheme } from '@dxp-module/themes'
import MainHeader from '../common/components/mainHeader/MainHeader'
import VehicleBanner from '../common/components/vehicleBanner/VehicleBanner'
import LoginContainer from './components/loginContainer/LoginContainer'
import loginOrSignupContainerStyles from './loginOrSignupContainer.styles'
import SignupRedirect from './components/Signup/SignupRedirect'

const LoginOrSignupContainer: FunctionComponent = () => {
  const styles = loginOrSignupContainerStyles()
  const {
    configuration: { spcUrl },
  } = useWidgetContext()
  const {
    features: { showBannerBackLink },
  } = useTheme<MyAccountTheme>()

  const backClickHandler = useCallback(() => {
    if (spcUrl) {
      window.location.href = document.referrer || spcUrl
    }
  }, [spcUrl])

  return (
    <Grid data-test="login-signup:container" className={styles.container}>
      <MainHeader
        headerTitle="trans__myaccount__create_an_account__login__header_sign_up_or_login"
        backLinkText="trans__myaccount__headers__back_cta"
        backClickHandler={backClickHandler}
        showBannerBackLink={!!showBannerBackLink}
      />
      <VehicleBanner
        pageName="login-signup"
        title="trans__myaccount__create_an_account__login__banner_title"
        description="trans__myaccount__create_an_account__login__banner_description"
        imageFilename="MyAccountBanner"
        classes={{ imageContainer: styles.imageContainer }}
      />
      <Grid className={styles.formContainer}>
        <Grid item md={6}>
          <SignupRedirect classes={{ root: styles.signup }} />
        </Grid>
        <Grid item md={6} className={styles.formContainerBox}>
          <LoginContainer className={styles.login} />
        </Grid>
      </Grid>
    </Grid>
  )
}

export default LoginOrSignupContainer
